module.exports = __webpack_public_path__ + "static/media/052-kosovo.b05e9974.svg";